import * as React from "react";
import "@aurodesignsystem/auro-input";
import "../OtsForm/AddOTSForm.scss";
import "./EditModal.scss";
import "@aurodesignsystem/auro-select";
import "@aurodesignsystem/auro-menu";
import "@aurodesignsystem/auro-combobox";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useEffect } from "react";
import { OtsAircraft } from "../../Models/OtsAircraft";
import dayjs from "dayjs";
import LabelInput from "../Label/Label-Input";
import { AuthorizationAccessCheck,useAuthorization,IsAuthorized } from "meportal/AuthorizationProvider";
import {ViewManageTab, EditProblemStatement, EditOTS_StartTime, EditStation, EditADVETRTime, EditATACode, EditLocation} from "../../constants/PermissionSet";
import * as Constants from "../../constants/Constants";
interface EditDetailsProps {
  onEditOts: OtsAircraft;
  ataCodeList: any[];
  onEditDataChange: any;
  reset: boolean;
  aircraftInFlight: boolean;
  airline: string;
}

export default function EditModalInput(props: EditDetailsProps) {
  const { onEditOts, ataCodeList, onEditDataChange } = props;
  const { eventPermissions, userClaims} = useAuthorization();

  const [station, setStation] = React.useState("");
  const [isStationValid, setIsStationValid] = React.useState(true);
  const [location, setLocation] = React.useState("");
  const [isLocationValid, setLocationValid] = React.useState(true);
  const [ataCode, setATACode] = React.useState("");
  const [ataCodeDescription, setATACodeDescription] = React.useState("");
  const [isATAValid, setisATAValid] = React.useState(true);
  const [validATACode, setvalidATACode] = React.useState<ATACode[]>([]);
  const [advtime, setAdvTime] = React.useState<Date | null>();
  const [etrtime, setEtrTime] = React.useState<Date | null>();
  const [otstime, setotsTime] = React.useState<Date | null>();
  const [problemText, setproblemText] = React.useState("");
  const [isAdvEtrValid, SetIsAdvEtrValid] = React.useState(true);
  const [isErrorAdvEtr, setShowErrorAdvEtr] = React.useState(false);
  const [problemTextCount, setProblemTextCount] = React.useState(0);
  const [isProblemTextValid, setIsProblemTextValid] = React.useState(true);
  const [isOtsValid, SetIsOtsValid] = React.useState(true);
  const [isErrorOts, setShowErrorOts] = React.useState(false);
  const [showAdvEtrLessThanOtsError, setShowAdvEtrLessThanOtsError] = React.useState({ showAdvEtrerror: false, showOtsError: false });
  const [showOtsFutureError, setShowOtsFutureError] = React.useState(false);
  const [showAdvEtrPastError, setShowAdvEtrPastError] = React.useState(false);
    const [AtaError, setAtaError] = React.useState(false);
  useEffect(() => {
    if(props.reset){
    setvalidATACode(ataCodeList);
    setStation(onEditOts.Station);
    setLocation(onEditOts.Location);
    setATACode(onEditOts.ATACode);
    setATACodeDescription(onEditOts.AtaCodeDescription);
    setAdvTime(
      onEditOts.AdviseTimeUTC ? formatTime(onEditOts.AdviseTimeUTC) : null
    );
    setEtrTime(
      onEditOts.EstimatedReturnToServiceTimeUTC
        ? formatTime(onEditOts.EstimatedReturnToServiceTimeUTC)
        : null
    );
    setotsTime(formatTime(onEditOts.OutOfServiceDateTimeUTC));
    setproblemText(onEditOts.ProblemText);

    //reset the validations
    setIsStationValid(true);
    setisATAValid(true);
    SetIsAdvEtrValid(true);
    setShowErrorAdvEtr(false);
    setIsProblemTextValid(true);
    SetIsOtsValid(true);
    setShowErrorOts(false);
    setShowAdvEtrLessThanOtsError({ showAdvEtrerror: false, showOtsError: false });
    setShowOtsFutureError(false);
    setShowAdvEtrPastError(false);
  }
  }, [props.reset, onEditOts]);
  useEffect(() => {
    validateForm();
  }, [
    station,
    isStationValid,
    location,
    ataCode,
    advtime,
    etrtime,
    isAdvEtrValid,
    problemText,
    isOtsValid,
    otstime,
    showAdvEtrLessThanOtsError,
    showOtsFutureError,
    showAdvEtrPastError,
    isLocationValid
  ]);

  const handleStationValue = (event: any) => {
    setStation(event.target.value.toUpperCase());
    setIsStationValid(event.target.isValid);
  };

    const handleBlurATA = (event: any) => {
        if (!isATAValid) {
            event.target.validity = "customError";
            event.target.isValid = false;
            event.target.__errorMessage = "Enter a valid ATA";
            setATACodeDescription("");
        }
    }

    const handleATAcode = (event: any) => {
        const { key } = event;
        if ((key >= '0' && key <= '9') || key == 'Backspace' || key == 'Tab' || key == 'ArrowLeft' || key == 'ArrowRight') { 
      const userAtaCode = event.target.value;
            if (ataCode != userAtaCode) {
                setATACode(userAtaCode);
                let result = Array.isArray(validATACode)
                    ? validATACode.map((e) => e.ChapterCode).includes(userAtaCode)
                    : null;
                if (userAtaCode.length == 0) {
                    setAtaError(true);
                }
               else if  (!result || (userAtaCode.length < 2 &&userAtaCode.length>0)) {
                    event.target.validity = "customError";
                    event.target.isValid = false;
                    event.target.__errorMessage = "Enter a valid ATA";
                    setATACodeDescription("");
                    setAtaError(true);
                } else {
                    let atadescription = Array.isArray(validATACode)
                        ? validATACode.find((e) => e.ChapterCode === userAtaCode)?.Description || ""
                        : "";
                    setATACodeDescription(atadescription);
                    setAtaError(false);

                }
      }
    
            setisATAValid(event.target.isValid);
        }
        else {
            event.preventDefault();
        }
  };
  const handleAdvTimeChange = (adv: Date | null) => {
    setShowErrorAdvEtr(false);
    SetIsAdvEtrValid(true);
    setAdvTime(adv);
    const currentDateTime = new Date();
    // Check if advTime is in the future
    if (adv && adv < currentDateTime) {
      setShowAdvEtrPastError(true);
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: false, showOtsError: false });
    }
    else if (adv && otstime && adv < otstime) {
      // Show error if advTime is less than otsTime
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: true, showOtsError: false });
      setShowAdvEtrPastError(false);
    } 
    else{
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: false, showOtsError: false });
      setShowAdvEtrPastError(false);
    }
    if (adv !== null) {
      setEtrTime(null);
    } else {
      if (etrtime === null) {
        setShowErrorAdvEtr(true);
        SetIsAdvEtrValid(false);
      }
    }
  };
  const handleOtsTimeChange = (ots: Date | null) => {
    setotsTime(ots);
    if(advtime && ots && advtime < ots){
      // Show error if advTime is less than otsTime
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: false, showOtsError: true });
    }
    else if(etrtime && ots && etrtime < ots){
      // Show error if etrTime is less than otsTime
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: false, showOtsError: true });
    }
    else{
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: false, showOtsError: false });
    }
// Check if otsTime is in the future
    const currentDateTime = new Date();
    if (onEditOts.Airline === "QX" && props.aircraftInFlight) {
      // For QX airline, if aircraft is in flight, allow OTS to be in the future
      setShowOtsFutureError(false);
    }
    else {
    if (ots && ots > currentDateTime) {
      // Show error if otsTime is in the future
      setShowOtsFutureError(true);
    }
    else{
      setShowOtsFutureError(false);
    }
  }
    if (ots == null) {
      setShowErrorOts(true);
      SetIsOtsValid(false);
    } else {
        setShowErrorOts(false);
        SetIsOtsValid(true);
    }
  };
  const handleInvalidOtsDate = (error: any) => {
    if (error !== null) {
      setShowErrorOts(true);
      SetIsOtsValid(false);
    }
  };
  const handleProblemTextValue = (event: any) => {
    const inputValue = event.target.value;
    // Strip HTML from the input value
    let strippedValue = stripHtmlTags(inputValue);    
    // Remove any characters that don't match the pattern
    const sanitizedProblem = strippedValue.replace(Constants.PROBLEMTEXT_LOCATION_REGEX_REPLACE, '');

    if (Constants.PROBLEMTEXT_LOCATION_REGEX_PATTERN.test(sanitizedProblem)) {
        event.target.value = sanitizedProblem;
        setproblemText(sanitizedProblem);
        setProblemTextCount(sanitizedProblem.length);
        setIsProblemTextValid(sanitizedProblem.length > 0);
    } 
};

const handleLocation = (event: any) => {
  const inputValue = event.target.value;
  // Strip HTML from the input value
  let strippedValue = stripHtmlTags(inputValue);
  // Remove any characters that don't match the pattern
  const sanitizedLocation = strippedValue.replace(Constants.PROBLEMTEXT_LOCATION_REGEX_REPLACE, '');

  if (Constants.PROBLEMTEXT_LOCATION_REGEX_PATTERN.test(sanitizedLocation)) {
      event.target.value = sanitizedLocation;
      setLocation(sanitizedLocation);
      setLocationValid(event.target.isValid);
  } 
};

  const handleInvalidDate = (error: any) => {
    if (error !== null && error !== "disablePast") {
      setShowErrorAdvEtr(true);
      SetIsAdvEtrValid(false);
    }
  };
  const handleEtrTimeChange = (etr: Date | null) => {
    setShowErrorAdvEtr(false);
    SetIsAdvEtrValid(true);
    setEtrTime(etr);
    const currentDateTime = new Date();
    // Check if advTime is in the future
    if (etr && etr < currentDateTime) {
      setShowAdvEtrPastError(true);
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: false, showOtsError: false });
    }
    else if (etr && otstime && etr < otstime) {
      // Show error if etrTime is less than otsTime
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: true, showOtsError: false });
      setShowAdvEtrPastError(false);
    } 
    else{
      setShowAdvEtrLessThanOtsError({ showAdvEtrerror: false, showOtsError: false });
      setShowAdvEtrPastError(false);
    }
    if (etr !== null) {
      setAdvTime(null);
    } else {
      if (advtime === null) {
        setShowErrorAdvEtr(true);
        SetIsAdvEtrValid(false);
      }
    }
  };
  const formatTime = (inputTime: string) => {
    const convertedTime = dayjs.utc(inputTime).local();
    return convertedTime.toDate();
  };
  const validateForm = () => {
    if (
      isStationValid &&
      isProblemTextValid &&
      isATAValid &&
      isAdvEtrValid &&
      isOtsValid &&
      !showAdvEtrLessThanOtsError.showAdvEtrerror && !showAdvEtrLessThanOtsError.showOtsError &&
      !showOtsFutureError &&
      !showAdvEtrPastError &&
      isLocationValid
    ) {
      //valid form
      sendData(false);
    } else {
      //invalid form
      sendData(true);
    }
  };

  const stripHtmlTags = (input: string) => {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.body.textContent || "";
  };

  const sendData = (isSubmitDisabled: boolean) => {
    console.log("send data called");
    if (isSubmitDisabled) {
      const editData = {
        isSubmitDisabled: isSubmitDisabled,
      };
      onEditDataChange(editData);
    } else {
      const editData = {
        station: station,
        location: location,
        advtime: advtime,
        etrtime: etrtime,
        ataCode: ataCode,
        ataCodeDescription: ataCodeDescription,
        otstime: otstime,
        problemText: problemText,
        isSubmitDisabled: isSubmitDisabled,
      };
      onEditDataChange(editData);
    }
  };

  const hasPermissionToEdit = (permission: string) => {
    return IsAuthorized(onEditOts?.Airline + ":" + onEditOts?.EventType, permission, eventPermissions, userClaims);
  }
  return (
    <span>
      <AuthorizationAccessCheck eventId={onEditOts?.Airline + ":" + onEditOts?.EventType} permission={ViewManageTab} returnBoolean={false}>       
      <div className="modal-edit-list">
        <LabelInput labelTitle="Aircraft #" labelContent={onEditOts?.AircraftRegistration} badge={onEditOts?.IsEtopsCapable === "true"}/>
        <div className="form-input">
          <auro-input
            data-testid="station"
            required
            validateOnInput
            bordered
            maxlength="3"
            minLength="3"
            pattern="[a-zA-Z]{3}"
            value={station}
            setCustomValidity="Enter a valid station"
            onInput={handleStationValue}
            class={hasPermissionToEdit(EditStation) ? "" : "disabled"}
          >
            <span className="label" slot="label">
              Station
            </span>
          </auro-input>
        </div>
        <div className="form-input">
          <auro-input
            validateOnInput
            bordered
            maxlength="10"
            setCustomValidity="Enter location within 10 chars"
            disabled={
              !hasPermissionToEdit(EditLocation) ? true :
              props.airline === "QX" ? null :
              !props.aircraftInFlight ? null : true
            }
            value={location}
            onInput={handleLocation}
            class={
              !hasPermissionToEdit(EditLocation) ? "disabled" :
              props.airline === "QX" ? "" :
              !props.aircraftInFlight ? "" : "disabled"
            }
          >
            <span className="label label-location" slot="label">
              Loc
            </span>
          </auro-input>
        </div>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <div className="form-input">
            <DateTimePicker
              label="ADV"
                          ampm={false}
                          timeSteps={{ minutes: 15 }}
              format="HH:mm MM/dd/yyyy"
              value={advtime}
              onChange={handleAdvTimeChange}
              onError={handleInvalidDate}
              disabled={hasPermissionToEdit( EditADVETRTime) ? false : true}
              disablePast={true}
            />
            {isErrorAdvEtr && (
              <span className="dateTimeError">Enter a valid ADV/ETR</span>
            )}
            {!isErrorAdvEtr && showAdvEtrLessThanOtsError.showAdvEtrerror && (
              <span className="dateTimeError">ADV/ETR should be greater than OTS</span>
            )}
            {!isErrorAdvEtr && showAdvEtrPastError && (
              <span className="dateTimeError">ADV/ETR can not be in the past</span>
            )}
          </div>

          <div className="form-input">
            <DateTimePicker
              label="ETR"
              ampm={false}
              format="HH:mm MM/dd/yyyy"
              timeSteps={{ minutes: 15 }}
              value={etrtime}
              onChange={handleEtrTimeChange}
              onError={handleInvalidDate}
              disabled={hasPermissionToEdit(EditADVETRTime) ? false : true}
              disablePast={true}
            />
          </div>
        </LocalizationProvider>
        <div className="form-input">
          <auro-input
            data-testid="ata-code"
                      required
                          maxLength={"2"}
                          setCustomValidity=" "
            validateOnInput
            bordered
                          value={ataCode}
            onBlur={handleBlurATA}
            onKeyUp={handleATAcode}
            onKeyDown={(e) => {
              handleATAcode(e);
            }}
            class={hasPermissionToEdit(EditATACode) ? "" : "disabled"}
          >
            <span  slot="label">
              ATA
            </span>
                      </auro-input>
                      {ataCode == "" && AtaError && < div className="dateTimeError">Please fill out this field</div>}
                      {ataCode != "" && AtaError && < div className="dateTimeError">Enter a valid ATA</div>}

        </div>
        <div className="form-input-max-grid">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="OTS start time"
              ampm={false}
              format="HH:mm MM/dd/yyyy"
              timeSteps={{ minutes: 15 }}
              value={otstime}
              onChange={handleOtsTimeChange}
              onError={handleInvalidOtsDate}
              sx={{ width: "100%" }}
              disabled={hasPermissionToEdit(EditOTS_StartTime) ? false : true}
            />
            {isErrorOts && (
              <div className="dateTimeError">Enter a valid OTS Time</div>
            )}
            {!isErrorOts && showOtsFutureError && (
              <div className="dateTimeError">OTS start time should not be in the future</div>
            )}
            {!isErrorOts && !showOtsFutureError && showAdvEtrLessThanOtsError.showOtsError && (
              <span className="dateTimeError">OTS should be less than ADV/ETR</span>
            )}
          </LocalizationProvider>
        </div>
      </div>

      <div className="problem-container-modal">
        <auro-input
          data-testid="problem-statement"
          className="problem-statemnent"
          required
          validateOnInput
          bordered
          maxlength="80"
          setCustomValidity="Enter valid problem statement"
          placeholder="enter problem statement"
          value={problemText}
          onInput={handleProblemTextValue}
          class={hasPermissionToEdit(EditProblemStatement) ? "" : "disabled"}
          
        >
          <span className="label" slot="label">
            Problem Statement
          </span>
          <span className="label helptext" slot="helptext">
            {problemTextCount > 0
              ? `${problemTextCount} characters (maximum 80 characters)`
              : "maximum 80 characters"}
          </span>
        </auro-input>
      </div>
      </AuthorizationAccessCheck>
    </span>
  );
}
